import React from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '@chargify/custom-ui-components';
import { FilterBox, FilterBoxProps } from '../FilterBox/FilterBox';
import { InvoiceStatus } from '../../../../models/billingHistory/billingHistory';
import { statuses } from '../../constants';

export interface StatusFilterProps extends Omit<FilterBoxProps, 'children'> {
  values: InvoiceStatus[];
  onChange: (status: InvoiceStatus[]) => void;
}
export const StatusFilter = ({
  onChange,
  values,
  onClick,
  header,
  isExpanded,
}: StatusFilterProps) => {
  const { t } = useTranslation('billing-history');
  const statusesWithLabels: { label: string; name: InvoiceStatus }[] =
    statuses.map((status) => ({
      label: t(status),
      name: status,
    }));
  return (
    <FilterBox onClick={onClick} isExpanded={isExpanded} header={header}>
      {statusesWithLabels.map(({ label, name }) => (
        <Checkbox
          onChange={() => {
            if (!values.includes(name)) {
              onChange([...values, name]);
            } else {
              onChange(values.filter((status) => status !== name));
            }
          }}
          key={name}
          label={label}
          name={name}
          value={values.includes(name)}
          id={name}
        />
      ))}
    </FilterBox>
  );
};
